export default {"src":"/_next/static/media/wallet-connect-visual3.bac1dcda.svg","height":124,"width":170,"blurWidth":0,"blurHeight":0};